// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen6V2_comp__rnClq"};